import { PiBracketsCurlyBold } from 'react-icons/pi';
import useModal from '@app/hooks/useModal';
import { useNodesEdges } from '../../contexts/useNodesEdges';
import { StyledButton } from '@app/components/button/Button';
import { StyledTooltip } from '@app/components/tooltip/Tooltip';
import FlowContextModal from '../modals/FlowContextModal';
import type { ContextVariable, ContextVariablesFormData } from '@app/services/aiFlow.types';

const FlowContextBtn = () => {
    const { contextVariables, setContextVariables } = useNodesEdges();
    const contextModal = useModal({ initialData: { contextVariables, setContextVariables } });

    const handleSubmit = (data: { variables: ContextVariablesFormData }) => {
        const dataWithType: ContextVariable[] = data.variables.map((d) => ({
            ...d,
            type: 'string',
            required: false,
        }));
        setContextVariables(dataWithType);
        contextModal.close();
    };

    return (
        <>
            <StyledTooltip title="Manage Context Variables">
                <StyledButton
                    type="primary"
                    icon={<PiBracketsCurlyBold size={20} />}
                    iconOnly
                    onClick={() => {
                        contextModal.open({ contextVariables, setContextVariables });
                    }}></StyledButton>
            </StyledTooltip>
            {contextModal.isOpen && (
                <FlowContextModal
                    open={contextModal.isOpen}
                    onCancel={() => contextModal.close()}
                    data={contextModal.data}
                    onSubmit={handleSubmit}
                />
            )}
        </>
    );
};

export default FlowContextBtn;
